module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/icon//icon-sword.png?v=eb06550b";